// extracted by mini-css-extract-plugin
module.exports = {"content":"Auth_content__YAIdf"};